module.exports = __webpack_public_path__ + "static/media/placeholder-video.d5b57d63.jpg";